module.exports = __webpack_public_path__ + "img/chatHeaderLogo.da2ea6f8.svg";